import Component from '@glimmer/component';
import {
  PrismButton,
  PrismComboSelectInput,
  PrismTooltip,
} from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import GeneralDropdownsTriggersTriggerDropdownIconButton from 'lumen/components/general/dropdowns/triggers/trigger-dropdown-icon-button';

export type Action = {
  actionHandler: () => void;
  dataTestId?: string;
  disabled?: boolean;
  disabledMessage?: string;
  icon: IconName;
};

export type AdditionalAction = {
  actionHandler: () => void;
  disabled?: boolean;
  disabledMessage?: string;
  label: string;
};

interface SettingsBudgetForecastTablesCellsTdWithActionsSignature {
  Args: {
    cellData: {
      actions: Action[];
      additionalActions: AdditionalAction[];
    };
  };
  Element: HTMLTableCellElement;
}

export default class SettingsBudgetForecastTablesCellsTdWithActions extends Component<SettingsBudgetForecastTablesCellsTdWithActionsSignature> {
  onSelectAdditionalAction(
    option: (typeof this.args.cellData.additionalActions)[number],
  ): void {
    option.actionHandler();
  }

  <template>
    <div data-test-td="with-actions">
      {{#each @cellData.actions as |a|}}
        <PrismButton
          @buttonType="secondary"
          @icon={{a.icon}}
          @isDisabled={{a.disabled}}
          @onClick={{a.actionHandler}}
          @size="small"
          data-test-action={{if a.dataTestId a.dataTestId}}
          data-test-icon={{a.icon}}
        >
          {{#if a.disabled}}
            {{#if a.disabledMessage}}
              <PrismTooltip @text={{a.disabledMessage}} />
            {{/if}}
          {{/if}}
        </PrismButton>
      {{/each}}

      {{#if @cellData.additionalActions.length}}
        <PrismComboSelectInput
          @onChange={{this.onSelectAdditionalAction}}
          @options={{@cellData.additionalActions}}
          @unsafe_triggerComponent={{component
            GeneralDropdownsTriggersTriggerDropdownIconButton
            buttonType="secondary"
            icon="kebab"
            small=true
          }}
          data-test-action-menu
        />
      {{/if}}
    </div>
  </template>
}
